import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { BackButton } from "~CJS/atoms/BackButton";
import OfferDetailInput from "~/components/block/OfferDetailInput";
// import { initialize, GetDetail, OfferFixApi } from "~stores/TALENTBANK/Offer";

import FavoriteIcon from "@material-ui/icons/Star";
// import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorderIcon";


import {
    Typography,
    Grid,
    Button,
    Card,
    CardContent,
    Box,
    Container,
    CardActions,
    IconButton,
    Paper,
} from '@material-ui/core';
import { initialize, GetMyOfferList, offer_set, offerDelete, OfferFixApi } from "~stores/TALENTBANK/Offer";
import { offer_template_set } from "~stores/TALENTBANK/OfferTemplate";
import { ButtonNavi } from "~CJS/block/ButtonNavi";

import FavoriteIcon2 from "@material-ui/icons/Favorite";
import ListAltIcon from "@material-ui/icons/ListAlt";




const OfferTemplateList = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const OfferState = useSelector((state) => state.Offer);

    useEffect(() => {
        // dispatch(initialize());
        dispatch(GetMyOfferList({ page: 1, status: '4' }));
    }, []);

    const handleApply = (offer_data) => {
        console.log(offer_data);
        dispatch(offer_template_set(['select_offer', offer_data]));
        history.push(`/sponsor/OfferNew`);
        // API呼び出しや状態更新など
    };

    const handleDelete = (offer_id) => {

        const result = window.confirm("本当に削除しますか？");
        if (!result) return;

        dispatch(offerDelete({ offer_info: { offer_id: offer_id } })).then(() => {

            dispatch(GetMyOfferList({ page: 1, status: '4' }));
        })
    };

    const handleFavorite = (offer_data) => {


        // お気に入り処理
        const new_offer_data = {
            ...offer_data,
            offer_template_favorite: offer_data?.offer_template_favorite ? null : '1',

        }

        dispatch(OfferFixApi({ offer_info: new_offer_data })).then(() => {

            dispatch(GetMyOfferList({ page: 1, status: '4' }));
        })

    };

    const handleSerch = (args) => {
        dispatch(GetMyOfferList({ page: 1, status: '4', ...args }));
    };
    return (


        <React.Fragment>
            <Container>
                {/* <BackButton history={history} /> */}
                <ButtonNavi left_label="戻る" left_link={`/sponsor/OfferNew`} />

                <Typography variant="h1">オファーテンプレート一覧</Typography>



                <Paper
                    elevation={3}
                    style={{
                        p: '1rem',
                        mb: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        flexWrap: "wrap",
                        borderRadius: 2,
                        backgroundColor: "#f9f9f9",
                    }}
                >
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        絞り込み
                    </Typography>

                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<FavoriteIcon2 />}
                            onClick={() => handleSerch({ offer_template_favorite: 1 })}
                        >
                            お気に入りのみ
                        </Button>

                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<ListAltIcon />}
                            onClick={() => handleSerch()}
                        >
                            すべて表示
                        </Button>
                    </Box>
                </Paper>


                <Grid container spacing={2} justifyContent="space-evenly">
                    {OfferState?.my_offer_list?.map((item, index) => (
                        <Grid item xs={12} md={5} lg={4} key={index}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {item.offer_title}
                                    </Typography>
                                    <Typography variant="body2">オファーID: {item.offer_id}</Typography>
                                    <Typography variant="body2">都道府県: {item.prefectures}</Typography>
                                    <Typography variant="body2">性別: {item.recruiting_sex}</Typography>
                                    <Typography variant="body2">年齢: {item.recruiting_age}</Typography>
                                    <Typography variant="body2">人数: {item.recruiting_count}</Typography>
                                </CardContent>
                                <CardActions>
                                    <Button variant="contained" color="primary" onClick={() => handleApply(item)}>
                                        反映
                                    </Button>
                                    <Button variant="outlined" color="secondary" onClick={() => handleDelete(item.offer_id)}>
                                        削除
                                    </Button>
                                    {/* <Button variant="text" onClick={() => handleFavorite(item.offer_id)}>
                                        お気に入り登録
                                    </Button> */}
                                    <IconButton
                                        onClick={() => handleFavorite(item)}
                                        color="error"
                                    >
                                        {item.offer_template_favorite ? <FavoriteIcon style={{ color: 'red' }} /> : <FavoriteIcon />}
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>



            </Container>
        </React.Fragment>
    );
};

export default OfferTemplateList;
